import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import { CleaverService } from 'src/app/services/cleaver.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-edit-cleaver-factor',
  templateUrl: './edit-cleaver-factor.component.html',
  styleUrls: ['styles.css'
  ]
})
export class EditCleaverFactorComponent implements OnInit {

  public factors=[];
  public selected = false;
  public factorSelected;
  public index=-1;

  public cleaverFactorForm = this.fb.group({
    type:['default'],
    personal:[[{
      low:[''],
      high:[''],
      d:[''],
      i:[''],
      s:[''],
      c:['']
    }]],
    behaviors:[[{
      combination:[''],
      title:[''],
      description:['']
    }]],
    maxMin:[[{
      tag:[''],
      description:[''],
      title:['']
    }]],
    _id:[''],
    __v:['']
  })

  public maxMinArray = [];
  public maxMin = {
    tag:"default",
    description:"",
    title:"",
    wish:'',
    require:''
  }

  public personalArray = [];
  public personal={
    low:Number,
    high:Number,
    d:"",
    i:"",
    s:"",
    c:""
  };

  public behaviorsArray = [];
  public behavior={
    combination:"default",
    title:"", 
    description:""
  };
  

  constructor(
    private cleaverService:CleaverService, 
    private adminService:AdminServiceService,
    private fb:FormBuilder
    ) 
    {
    this.cleaverService.getFactors().subscribe(
      resp=>{
        this.factors = resp;
      },
      err=>{
        console.log(err);
      }
    )
   }

  ngOnInit(): void {
  }

  handleDelete(factor){
    var opc = confirm("¿Eliminar factor?");
    if (opc){

      this.adminService.deleteFactor('cleaver',factor._id).subscribe(
        resp=>{
          window.location.reload()
        },
        err=>console.log(err)
      )
    }

  }

  handleEdit(factor){
    this.selected = true;
    this.factors.map(x=>{
      if (x._id == factor._id) this.factorSelected = x;
    })
    this.cleaverFactorForm.setValue(this.factorSelected);
    this.personalArray = this.factorSelected.personal;
    this.behaviorsArray = this.factorSelected.behaviors;
    this.maxMinArray = this.factorSelected.maxMin;


  }


  addPersonal(){
    if(this.personal.high>this.personal.low){
      this.personalArray.push(this.personal);
      this.personal={
        low:Number,
        high:Number,
        d:"",
        i:"",
        s:"",
        c:""
      };

    }
  }

  addBehavior(){
    if(this.behavior.combination!='default'){
      this.behaviorsArray.push(this.behavior);
      this.behavior={
        combination:"default",
        title:"", 
        description:""
      };
    }
  }

  addMaxMin(){
    if(this.maxMin.tag!='default'){
      this.maxMinArray.push(this.maxMin);
      this.maxMin={
        tag:"default",
        title:"", 
        description:"",
        wish:'',
        require:''
      };
    }
  }

  update(){
    this.cleaverFactorForm.get('personal').setValue(this.personalArray);
    this.cleaverFactorForm.get('behaviors').setValue(this.behaviorsArray);
    this.cleaverFactorForm.get('maxMin').setValue(this.maxMinArray);
    this.cleaverService.createFactor(this.cleaverFactorForm.value).subscribe(
      resp=>{
        this.personalArray=[];
        this.maxMinArray=[];
        this.behaviorsArray=[];
        this.cleaverFactorForm.reset();
        let timerInterval
        Swal.fire({
          title: 'Factor actualizado',
          html: '',
          timer: 1000,
          timerProgressBar: true,
          willOpen: () => {
            Swal.showLoading()
          },
          onClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            window.location.reload();
          }
        })
      },
      err=>{
        console.log(err);
      }
    )
  }

  handleEditPersonal(p,i){
    this.personal = p;
    this.index = i;
  }

  handleEditBehavior(p,i){
    this.behavior = p;
    this.index = i;
  }

  handleEditMaxMin(p,i){
    this.maxMin = p;
    this.index = i;
  }

  updatePersonal(){
    this.personalArray[this.index] = this.personal;
  }

  updateBehavior(){
    this.behaviorsArray[this.index] = this.behavior;
  }

  updateMaxMin(){
    this.maxMinArray[this.index] = this.maxMin;
  }

}
